import { configureStore } from "@reduxjs/toolkit";
import messageReducer from "./messageSlice";
import authReducer from "./authSlice";
// import companyReducer from "./companySlice";
import appReducer from "./appSlice";
import employeeReducer from "./employeeSlice"
import {
  TypedUseSelectorHook,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from "react-redux";
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session'; // セッションストレージを使用（ブラウザ閉鎖時に自動消去）
import { combineReducers } from 'redux';

// すべてのリデューサーをまとめる
const rootReducer = combineReducers({
  message: messageReducer,
  auth: authReducer,
  // company: companyReducer,
  employee: employeeReducer,
  store: appReducer,
});

// persistConfigの設定
const persistConfig = {
  key: 'root',
  storage: storageSession,
};

// 永続化されたリデューサーを作成
const persistedReducer = persistReducer(persistConfig, rootReducer);

// ストアの設定
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production",
});

// persistorの作成
const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// 型付きの useDispatch と useSelector フックをエクスポート
export const useDispatch = () => useReduxDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export { store, persistor };
